import React, { CSSProperties, FunctionComponent } from "react";
import { ButtonGroup } from "@mui/material";
import IconSelectorButton from "@/components/IconSelectorButton";

export type ButtonItem<T> = {
  text: string;
  Icon: FunctionComponent;
  id: T;
};

export interface TrialItemModuleProps<T> {
  buttons: ButtonItem<T>[];
  selectedButtonId: T;
  setButtonId: (id: T) => void;
  style?: CSSProperties;
}

const TextButtonGroup = <T extends any>({
  buttons,
  selectedButtonId,
  setButtonId,
  style,
}: TrialItemModuleProps<T>) => (
  <ButtonGroup
    fullWidth
    disableElevation
    disableRipple
    variant="outlined"
    style={style}
  >
    {buttons.map((x) => (
      <IconSelectorButton
        key={x.text}
        Icon={x.Icon}
        mainText={x.text}
        variant="outline"
        selected={x.id === selectedButtonId}
        onClick={() => setButtonId(x.id)}
      />
    ))}
  </ButtonGroup>
);

export default TextButtonGroup;
